<template>
  <div class='h100-40 h-scroll'>
    <ejs-grid ref='grid' height='calc(100% - 0px)' :dataSource='data'
              :selectionSettings='selectionOptions' :allowReordering='true' :allowResizing='true' :allowExcelExport='true' >
      <e-columns :columns='shipColumns' textAlign='Center' clipMode='EllipsisWithTooltip'>
        <e-column field='neId' minWidth='10' :headerText='$t("DeployManagement.nodeID")' textAlign='Center' width="120" clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='neName' minWidth='10' :headerText='$t("DeployManagement.nodeName")' textAlign='Center' width="120" clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='moName' minWidth='10' :isPrimaryKey='true' :headerText='$t("MML.moName")' textAlign='Center' width="120" clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='key' minWidth='10' :headerText='$t("Observe.attributeValues")' textAlign='Center' width="120" clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='value' minWidth='10' :headerText='$t("DeployManagement.value")' textAlign='Center' width="120" clipMode='EllipsisWithTooltip'></e-column>
      </e-columns>
    </ejs-grid>
    <ejs-pager ref='pager' @click='getParamListData()' :currentPage='page.pageNo' :pageSize='page.pageSize' :totalRecordsCount='page.totalCount' :pageCount='page.pageCount'></ejs-pager>
  </div>
</template>
<script>
  import { createNamespacedHelpers } from 'vuex';
  import { Reorder, Resize, ExcelExport, ContextMenu } from '@syncfusion/ej2-vue-grids';
  import bus from '../bus.js';
  import { EventBus } from '../../../plugins/eventBus';
  import socketInstance from '../../../plugins/stompSock';

  const { mapGetters, mapActions } = createNamespacedHelpers('trackConfig');
  export default {
    name: 'configExTable',
    components: {
    },
    props: ['trackType'],
    data() {
      return {
        selectionOptions: { type: 'Single' },
        queryConditions: {
          keywords: '' // 任务名称模糊查询关键字
        },
        keywords: '',
        currentNeInfo: '',
        data: [],
        primaryDatas: [],
        page: {
          pageNo: 1,
          pageSize: 20,
          totalCount: 0,
          pageCount: 10
        },
        currentSelectDataId: '',
        shipColumns: [
          {
            field: 'ShippedDate',
            headerText: 'Shipped Date',
            format: 'yMd',
            textAlign: 'Right',
            width: 150,
            minWidth: 10
          },
          {
            field: 'ShipCountry',
            headerText: 'Ship Country',
            width: 150,
            minWidth: 10
          }
        ]
      };
    },
    computed: {
      ...mapGetters(['currentNe']),
      ...mapGetters(['neVisionList']),
      ...mapGetters(['resourceIdList'])
    },
    provide: {
      grid: [Reorder, Resize, ExcelExport, ContextMenu]
    },
    methods: {
      ...mapActions(['setCurrentNe']),

      menuBeforeOpenFunc(menuArgs) { // 屏蔽表头的右键事件
        if (!menuArgs.rowInfo.rowIndex && menuArgs.rowInfo.rowIndex !== 0) {
          menuArgs.cancel = true;
          return;
        }
        const childList = menuArgs.element.querySelectorAll('li.e-menu-item');
        childList.forEach(elem => {
          elem.style.display = 'block';
        });
      },

      getParamListData(params) {
          //  if(typeof(this.keywords)==undefined || this.keywords ==''){
          //   EventBus.$emit('toast', {type: 'warning', content: this.$t('Topo.pleaseSelect')});
          //   return;
          //  }
           params.pageNo=this.page.pageNo;
           params.pageSize=this.page.pageSize;
           this.$axios.post('/lte/ems/config/mml/querySameData',params).then((response) => {
              if (response && response.status === 200) { 
                this.data = response.data.resultVal.data;
                    this.page.totalCount = response.data.resultVal.totalCount;
                    this.page.pageNo =this.page.pageNo;
                    this.page.pageSize = this.page.pageSize,
                    this.page.pageCount =response.data.resultVal.pageCount;
              } else {
                EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
              }
            });
        }
    },
    mounted() {
    },
    beforeDestroy() {
      bus.$off('refreshTrackTable');
    }
  };
</script>
